<template>
  <div>
    <v-card v-if="hideSection" class="mt-3">
      <v-card-title>
        <span>{{ sectionLabel }}</span>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-alert type="info" border="left" dense class="mb-3" v-if="sectionInfoBox">
          {{sectionInfoBox}}
        </v-alert>
        <el-form :model="form" ref="form" label-position="top" class="yukon-checkbox">
          <v-row dense>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_last_name')">
              <el-form-item prop="officer_sign_last_name" label="Last Name">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_last_name" />
              </el-form-item>
            </v-col>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_first_name')">
              <el-form-item prop="officer_sign_first_name" label="First Name">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_first_name" />
              </el-form-item>
            </v-col>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_title')">
              <el-form-item prop="officer_sign_title" label="Title">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_title" />
              </el-form-item>
            </v-col>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_phone')">
              <el-form-item prop="officer_sign_phone" label="Phone">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_phone" />
              </el-form-item>
            </v-col>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_fax')">
              <el-form-item prop="officer_sign_fax" label="Fax">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_fax" />
              </el-form-item>
            </v-col>
            <v-col cols="12" sm="6" v-if="dataValidation(form, 'officer_sign_confidential_email')">
              <el-form-item prop="officer_sign_confidential_email" label="Confidential email">
                <el-input @change="handleAutoSave(form)" v-model="form.officer_sign_confidential_email" />
              </el-form-item>
            </v-col>
          </v-row>
        </el-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn :loading="autoSave" :disabled="autoSave" color="primary" small @click.native="handleAutoSave(form)">
          {{ $t('global.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import autosave from '@/mixins/lmia_autosave'

export default {
  mixins: [autosave],
  props: {
    isDataValidation: {
      type: Boolean
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      edit: false,
      form: {
        application_id: this.$route.params.id,
        sec_org_id: parseInt(localStorage.getItem('org_id')),
        officer_sign_last_name: null,
        officer_sign_first_name: null,
        officer_sign_title: null,
        officer_sign_phone: null,
        officer_sign_fax: null,
        officer_sign_confidential_email: null
      },
      url: 'imms_table/lmia_yukon_app',
      getUrl: 'imms_table/lmia_yukon_app?application_imms_uuid=' + this.$route.params.id
    }
  },
  mounted() {
    this.fetch().then(data => {
      if (data.items != undefined && data.items.length > 0) {
        if (this.isDataValidation) {
          this.checkRow(data.items[0])
        }
        this.form = data.items[0]
      }
      else {
        if (this.isDataValidation) {
          this.checkRow(this.form)
        }
      }
    })
  }
}
</script>
